import { AnyAction } from "redux";
import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  createFailure,
  createSuccess,
  editFailure,
  editSuccess,
  listFailure,
  listRequest,
  listSuccess
} from "../actions/pricingGroups";
import { PricingGroupsActionsTypes } from "../types/PricingGroups.reducer.types";

import { SagaCustomError } from "@/common/types";
import { PricingGroupsService } from "@/core/libs/api";
import { messageBarTypes } from "@/core/libs/message-bar";

const abortController = new AbortController();
const { signal } = abortController;

function* createPricingGroup({ payload }: AnyAction) {
  const { values, setSubmitting, closePanel, isAdmin = false } = payload;
  const service = PricingGroupsService("", isAdmin);

  setSubmitting(true);

  try {
    const response = yield call(service.create, {
      params: { body: { ...values } },
      signal
    });

    if (response.error) {
      const error: SagaCustomError = new Error();
      error.statusCode = response.error.status;

      throw error;
    }

    yield put(
      createSuccess({
        message: `Grupo de precificação criado com sucesso.`,
        type: messageBarTypes.SUCCESS
      })
    );

    if (closePanel) {
      setTimeout(() => {
        closePanel();
      }, 1000);
    }

    // REFRESH LIST
    yield put(listRequest(undefined, isAdmin));
  } catch (error) {
    yield put(
      createFailure({
        code: error?.statusCode,
        message:
          "Não foi possível criar o grupo de precificação com os dados informados.",
        type: messageBarTypes.ERROR
      })
    );
  }

  setSubmitting(false);
}

function* editPricingGroup({ payload }: AnyAction) {
  const { values, setSubmitting, closePanel, isAdmin = false } = payload;
  const service = PricingGroupsService("", isAdmin);

  setSubmitting(true);

  try {
    const response = yield call(service.edit, {
      params: { body: { ...values } },
      signal
    });

    if (response.error) {
      const error: SagaCustomError = new Error();
      error.statusCode = response.error.status;

      throw error;
    }

    yield put(
      editSuccess({
        message: `Grupo de precificação editado com sucesso.`,
        type: messageBarTypes.SUCCESS
      })
    );

    if (closePanel) {
      setTimeout(() => {
        closePanel();
      }, 1000);
    }

    // REFRESH LIST
    yield put(listRequest(undefined, isAdmin));
  } catch (error) {
    yield put(
      editFailure({
        code: error?.statusCode,
        message:
          "Não foi possível editar o grupo de precificação com os dados informados.",
        type: messageBarTypes.ERROR
      })
    );
  }

  setSubmitting(false);
}

function* listPricingGroups({ payload }: AnyAction) {
  const { filter, isAdmin = false } = payload;
  const service = PricingGroupsService("", isAdmin);

  try {
    const params = { query: { page: 1, limit: 10 } };

    if (filter) {
      params.query = { ...params.query, ...filter };
    }

    const response = yield call(service.list, { params, signal });

    if (response.error) {
      throw new Error();
    }

    yield put(listSuccess({ list: response.data }));
  } catch (error) {
    yield put(listFailure());
  }
}

export default all([
  takeLatest(PricingGroupsActionsTypes.CREATE_REQUEST, createPricingGroup),
  takeLatest(PricingGroupsActionsTypes.EDIT_REQUEST, editPricingGroup),
  takeLatest(PricingGroupsActionsTypes.LIST_REQUEST, listPricingGroups)
]);
